Wee.fn.make('newsletter', {
	init: function() {
		this.$form = $('ref:newsletterForm');

		this.bind();
	},

	bind: function() {
		this.$form.on('submit', function(e, el) {
			var address = $(el).find('input')[0].value;

			if (this.validate(address)) {
				this.clearErrors();

				$('ref:signUp').addClass('-is-sending');

				this.subscribe(address);
			} else {
				this.clearErrors();

				this.addError('Please provide a valid email.');
			}

			e.preventDefault();
		}.bind(this));
	},

	validate: function(address) {
		var regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]*@[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]*\.[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]{2,}/;

		return regex.test(address);
	},

	subscribe: function(address) {
		var scope = this;

		$.fetch.request({
			url: '/ajax/subscribe/' + address,
			success: function() {
				$('ref:signUp').removeClass('-is-sending');

				$('ref:signUp').html('Success!').addClass('-is-submitted');

				scope.$form.off('submit');
			}
		});
	},

	clearErrors: function() {
		$('ref:formError').remove();
	},

	addError: function(message) {
		var div = document.createElement('div');

		div.setAttribute('data-ref', 'formError');
		div.className += 'form-error';
		div.innerHTML = message;

		this.$form.append(div);

		$.setRef();
	}
});